module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"土日傾向"}}')
  delete Component.options._Ctor
}
